module.exports = __webpack_public_path__ + "static/media/we.731e48c9.mp3";